import '@styles/Input/style.css'
import cn from 'classnames'
import React, { CSSProperties, forwardRef, InputHTMLAttributes } from 'react'
import Typography, { Variants as TypographyVariants } from '../Typography'

type Variants = 'standard' | 'outlined' | 'secondary'
export interface IInput extends InputHTMLAttributes<HTMLInputElement> {
  variant: Variants
  type?: 'text' | 'password' | 'number'
  textAlign?: 'start' | 'center' | 'end'
  error?: string
  style?: CSSProperties
  hideNumberArrows?: boolean
  textVariant?: TypographyVariants
}

const Input = forwardRef<HTMLInputElement, IInput>(
  (
    {
      variant,
      type = 'text',
      textAlign = 'start',
      error,
      className,
      hideNumberArrows,
      textVariant,
      ...props
    },
    ref
  ): JSX.Element => {
    return (
      <>
        <input
          ref={ref}
          className={cn(
            {
              [`input--variant-${variant}`]: variant,
              [`typography--variant-${variant}`]: textVariant,
              [`input--textAlign-${textAlign}`]: textAlign,
              [`input--error`]: error,
              // eslint-disable-next-line no-useless-computed-key
              ['input--hide-arrows']: hideNumberArrows
            },
            className
          )}
          {...props}
          type={type}
        ></input>
        {error && (
          <Typography variant='body1' color='error' style={{ position: 'absolute' }}>
            {error}
          </Typography>
        )}
      </>
    )
  }
)

export default Input
